import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import _ from "lodash";
import { mypRoles } from "../../utils/mappingData";
import UserManagerHeader from "../../components/Users/UserManager/UserManagerHeader";
import UserManagerTable from "../../components/Users/UserManager/UserManagerTable";
import { CardElement } from "../../components/Common/UIElements";
import { useUserSearch } from "../../hooks/user.hooks";
import { Empty } from "antd";
// import { mypRoles } from "../../../";

const mypRolesKey = _.keyBy(mypRoles, "id");

const UserManager = () => {

  const [initialDataLoad, setInitialDataLoad] = useState(true);
  const [hmgId, setHmgId] = useState();
  const [hotelId, setHotelId] = useState();
  const [search, setSearch] = useState("");
  const [userData, setUserData] = useState();

  const tableRef = useRef(null);

  const exportData = () => {
    tableRef.current.exportOnClick();
  };

  const { mutateAsync: getUserData, isLoading } = useUserSearch();

  const permission = useSelector((state) => state.api?.permission);

  const submitFn = async () => {
    const result = await getUserData({
      hmg_id: hmgId,
      hotel_id: hotelId,
      search,
    });
    const dataArray = result?.data ?? [];
    setUserData(
      dataArray.map((e) => {
        const newItem = { ...e };
        newItem.main_role = e?.main_role?.main_role_name ?? null;
        newItem.role = e?.role?.role_name ?? null;
        if (e.status) {
          if (e.welcome_reset_status) {
            newItem.status = "Active";
          } else if (
            e.user_invitation_sent &&
            e.user_invitation_sent_date &&
            moment().isBefore(
              moment(e.user_invitation_sent_date).add(48, "hours"),
            )
          ) {
            newItem.status = "Pending";
          } else {
            newItem.status = "Created";
          }
        } else {
          newItem.status = "Inactive";
        }
        newItem.custom_permission = e.custom_permission ? "Enable" : "Disable";
        newItem.use_mfa = e.use_mfa ? "Enable" : "Disable";
        newItem.myp_role =
          e.myp_role &&
          mypRolesKey &&
          mypRolesKey[e.myp_role] &&
          mypRolesKey[e.myp_role].name
            ? mypRolesKey[e.myp_role].name
            : null;
        newItem.create_by = e?.create_by?.name ?? null;
        newItem.create_at = e.create_at
          ? moment(e.create_at).local().format("YYYY-MM-DD HH:mm:ss")
          : null;
        newItem.update_by = e?.update_by?.name ?? null;
        newItem.update_at = e.update_at
          ? moment(e.update_at).local().format("YYYY-MM-DD HH:mm:ss")
          : null;
        return newItem;
      }),
    );
  };


  return (
    <div className="containerTitleStyles">
      <div className="container_ab">
        <CardElement title="User Management">
          <UserManagerHeader
            setHmgId={setHmgId}
            hmgId={hmgId}
            hotelId={hotelId}
            setHotelId={setHotelId}
            search={search}
            setSearch={setSearch}
            submitFn={submitFn}
            isLoadingData={isLoading}
            exportOnClick={exportData}
            initialDataLoad={initialDataLoad}
            setInitialDataLoad={setInitialDataLoad}
          />
          {
            !initialDataLoad && Array.isArray(userData) ? (
              <UserManagerTable
                tableOneData={userData}
                permission={permission}
                ref={tableRef}
              />
            ) : null
            // (
            // <Empty
            //   description={(
            //     <span>
            //       Please select your <b>Filters</b> and click the <b>Go Button</b>
            //     </span>
            //   )}
            // />
            // )
          }
        </CardElement>
      </div>
    </div>
  );
};

export default UserManager;
